export const formatDataDictionaryBody = (data: any) => {
  const selected: any = {
    screening: [],
    visits: [],
    repeating_data: [],
    surveys: [],
    visitsPhaseIds: [],
    screeningPhaseIds: [],
    repeatingDataPhaseIds: [],
    surveysPhaseIds: [],
    surveyPackageIds: [],
  };
  data.data.forEach((item: any) => {
    item.formattedData.forEach((phase: any) => {
      const formIds: any[] = [];
      phase?.forms?.forEach((form: any) => {
        if (form.selected) {
          formIds.push(form.id);
        }
      });
      if (phase.category === "visit") {
        if (formIds.length > 0 && formIds.length === phase?.forms?.length) {
          selected.visitsPhaseIds.push(phase.id);
        } else if (formIds.length > 0) {
          selected.visits.push(...formIds);
        }
      } else if (phase.category === "survey") {
        if (formIds.length > 0 && formIds.length === phase?.forms?.length) {
          selected.surveysPhaseIds.push(phase.id);
        } else if (formIds.length > 0) {
          selected.surveys.push(...formIds);
        }
      } else if (phase.category === "repeated_data") {
        if (formIds.length > 0 && formIds.length === phase?.forms?.length) {
          selected.repeatingDataPhaseIds.push(phase.id);
        } else if (formIds.length > 0) {
          selected.repeating_data.push(...formIds);
        }
      } else if (phase.category === "survey_package") {
        if (phase.selected === "yes") {
          selected.surveyPackageIds.push(phase.id);
        }
      } else if (phase.category === "screening") {
        if (formIds.length > 0 && formIds.length === phase?.forms?.length) {
          selected.screeningPhaseIds.push(phase.id);
        } else if (formIds.length > 0) {
          selected.screening.push(...formIds);
        }
      }
    });
  });

  return selected;
};
